import styled from 'styled-components';


export const LoaderContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: #F5F7FA;
  z-index: 100;
  opacity: 0.8;
  top: 0;
  left: 0;

  div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate( -50%, -50% );
  }
`;


export const Title = styled.h3`
  font-size: 18px;
  margin: 0;
  text-transform: capitalize; 
`;

export const Cnpj = styled.p`
  font-size: 18px;
  margin: 5px 0 40px;
  text-transform: capitalize; 
`;

